//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';
import _ from 'underscore';

import { ISystemAlertDto } from '@apis/system-alerts/systemAlertsApiModels';
import 'app/angular-apis/systemAlertsApi.service';
import { SystemAlertsApiService } from 'app/angular-apis/systemAlertsApi.service';
import { Alert } from './Alert';

interface IAlertsRecord {
  error: Alert[];
  info: Alert[];
}

function hydrateActiveAlerts(alertDtos: ISystemAlertDto[]): Alert[] {
  return alertDtos
    .map((alertDto) => Alert.fromDto(alertDto))
    .filter((alert) => !alert.isDismissed);
}

const getBrowserDeprecationBanner = (): [ISystemAlertDto] | [] => {
  if ($.browser.msie || ($.browser.safari && $.browser.versionNumber < 11)) {
    return [
      {
        message:
          'Your browser is no longer officially supported by Bazaarvoice.',
        linkText: 'Learn More',
        linkTarget:
          'https://support.bazaarvoice.com/s/article/Supported-Web-Browsers',
      },
    ];
  }
  return [];
};

class SystemAlertsService {
  private getAlerts: () => Promise<IAlertsRecord> = _.once(async () => {
    const res = await this.systemAlertsApiSerivce.getSystemAlerts();

    const localErrorAlerts = [...getBrowserDeprecationBanner()];
    return {
      error: hydrateActiveAlerts([...res.error, ...localErrorAlerts]),
      info: hydrateActiveAlerts(res.info),
    };
  });

  constructor(
    private readonly systemAlertsApiSerivce: SystemAlertsApiService,
  ) {}

  public async getErrorAlerts() {
    return (await this.getAlerts()).error;
  }

  public async getInfoAlerts() {
    return (await this.getAlerts()).info;
  }
}

angular
  .module('curalate')
  .service('SystemAlertsService', [
    'SystemAlertsApiService',
    SystemAlertsService,
  ]);
